export default __webpack_public_path__ + "icon_newsletter.cc269bad97a689e58312472cc965f476.svg";